import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { appendSectionHeadlineReveal } from "./section-headline-gsap.js";

gsap.registerPlugin(ScrollTrigger);

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

if (!reducedMotion) {
  const auswahlHeadline = document.querySelector(
    ".page-section__headline--unsere-auswahl",
  );
  if (auswahlHeadline) {
    gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: auswahlHeadline,
          start: "top 85%",
          toggleActions: "play none none none",
        },
        defaults: { ease: "power2.out" },
      });
      appendSectionHeadlineReveal(tl, auswahlHeadline, 0, { withRule: true });
    }, auswahlHeadline);
  }

  document.querySelectorAll(".image-tile").forEach((block) => {
    const headline = block.querySelector(".image-tile__headline");
    if (!headline) {
      return;
    }

    gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: headline,
          start: "top 65%",
          toggleActions: "play none none none",
        },
        defaults: { ease: "power2.out" },
      });

      appendSectionHeadlineReveal(tl, headline, 0, {
        withRule: false,
        textY: 44,
      });
    }, block);
  });
}
